module.exports = __webpack_public_path__ + "img/information.af706107.svg";